module.exports = __webpack_public_path__ + "img/contact.b85e70d3.svg";